export const ADVISOR_PROFILE_ACTIONS = [
  {
    label: 'Schedule a meeting',
    param: 'scheduleMeeting',
  },
  {
    label: 'Chat with a planner',
    param: 'chat',
  },
  {
    label: 'Grant access to data',
    param: 'grantAccess',
  },
  {
    label: 'Revoke access to data',
    param: 'revokeAccess',
  },
]
